import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A power-station cooling tower: the iconic concrete hyperboloid that pinches in
// at the waist and flares at the rim, with a pale plume of steam rising from the
// open top. Approximated as stacked cylinders so the waist reads from any angle.
const CONCRETE = "#cfcabb";
const SHADE = "#b9b4a6";
const STEAM = "#eef0f2";

export const coolingTower = defineModel({
  id: "cooling-tower",
  batchId: "electric",
  name: "Cooling tower",
  tags: ["building", "electric", "power", "energy", "cooling", "plant"],
  summary: "A concrete hyperboloid cooling tower venting a plume of steam.",
  footprint: 0.7,
  parts(): Part[] {
    return [
      { geometry: new THREE.BoxGeometry(1.05, 0.12, 1.05), color: "#6f6f74", position: [0, 0.06, 0] },
      // Flared base ring.
      { geometry: new THREE.CylinderGeometry(0.46, 0.64, 0.16, 18), color: SHADE, position: [0, 0.2, 0] },
      // The hyperboloid: base flares in to a deep waist, then re-flares to the
      // rim, so the pinched "waist" reads from every angle.
      { geometry: new THREE.CylinderGeometry(0.36, 0.5, 0.5, 18), color: CONCRETE, position: [0, 0.53, 0] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.36, 0.45, 18), color: CONCRETE, position: [0, 1.0, 0] },
      { geometry: new THREE.CylinderGeometry(0.42, 0.3, 0.45, 18), color: CONCRETE, position: [0, 1.45, 0] },
      // Top lip flare and dark open mouth.
      { geometry: new THREE.CylinderGeometry(0.46, 0.42, 0.06, 18), color: SHADE, position: [0, 1.7, 0] },
      { geometry: new THREE.CylinderGeometry(0.4, 0.4, 0.05, 18), color: "#3a3a3e", position: [0, 1.71, 0] },
      // Steam: a loose, rising column of separated puffs lifted clear of the rim
      // so the open mouth stays visible. Sparse and drifting, not a solid cap.
      { geometry: new THREE.SphereGeometry(0.22, 9, 7), color: STEAM, position: [-0.12, 1.92, 0.08], scale: [1, 0.7, 1] },
      { geometry: new THREE.SphereGeometry(0.18, 9, 7), color: "#f6f7f9", position: [0.14, 2.04, -0.06], scale: [1, 0.7, 1] },
      { geometry: new THREE.SphereGeometry(0.2, 9, 7), color: "#fafbfc", position: [-0.02, 2.18, 0.05], scale: [1, 0.75, 1] },
      { geometry: new THREE.SphereGeometry(0.15, 8, 6), color: "#f4f6f8", position: [0.1, 2.36, 0.06], scale: [1, 0.8, 1] },
      { geometry: new THREE.SphereGeometry(0.12, 8, 6), color: "#fcfdfe", position: [-0.06, 2.5, -0.04] },
    ];
  },
  animations: [],
});
